import properties from '../../../modules/ajio-util/properties';

const parentUrl = `${properties.getProperty('parentUrl')}`;
const imageBasePath = `${properties.getProperty('imageBaseUrl')}/static/img/`;
const audioBasePath = `${properties.getProperty('imageBaseUrl')}/static/audios/`;
const { innerWidth = 320 } = window || {};

export const WHEEL_WIDTH = innerWidth > 360 ? 360 : innerWidth;

export const GAMIFICATION_ICONS = {
  WHEEL_AJIO_LOGO: `${imageBasePath}stw-ajio-white.svg`,
  M_H_CLOSE_ICON: `${imageBasePath}stw-mn-cls-icn.svg`,
  M_H_RULES_ICON: `${imageBasePath}stw-mn-ruls-icn.svg`,
  M_H_MYREWARDS_ICON: `${imageBasePath}stw-mn-myrds-icn.svg`,
  AJIO_POINT_ICON: `${imageBasePath}stw-ajio-ptns-icn.png`,
  COUPON_ICON: `${imageBasePath}stw-coupon-icn.svg`,
  MODAL_CIRCLE_CLOSE_ICON: `${imageBasePath}stw-modal-close-icn.svg`,
  PRIZE_ICON: `${imageBasePath}stw-prize-icn.svg`,
  SHARE_THEME_ICON: `${imageBasePath}stw-share-thm-icn.svg`,
  CHECK_GREEN_ICON: `${imageBasePath}stw-check-grn-icn.svg`,
  GENIE_ICON: `${imageBasePath}stw-genie-icn.svg`,
  GIFT_ICON: `${imageBasePath}stw-gift-icn.svg`,
  TIMER_ICON: `${imageBasePath}stw-timer-icn.png`,
  SPEAKER_ACTIVE_ICON: `${imageBasePath}stw-spkr-icn.svg`,
  SPEAKER_INACTIVE_ICON: `${imageBasePath}stw-spkr-mute-icn.svg`,
  BG_THEME: `${imageBasePath}stw-bg-theme.svg`,
  AJIO_CASH_ICON: `${imageBasePath}gm-ajio-cash.svg`
};

export const GET_GAME_INFO_API_ERROR_MESSAGES = [
  {
    errorCode: 454,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    icon: GAMIFICATION_ICONS.GIFT_ICON,
    btnText: 'Continue Shopping'
  },
  {
    errorCode: 500,
    errorMessage: 'Hey we are experiencing heavy traffic.<br />Please check in sometime',
    icon: GAMIFICATION_ICONS.TIMER_ICON,
    btnText: 'Okay'
  },
  {
    errorCode: 501,
    errorMessage: 'Oops! Something went wrong.<br />Please retry again.',
    icon: GAMIFICATION_ICONS.GENIE_ICON,
    btnText: 'Okay'
  },
  {
    errorCode: 504,
    errorMessage: 'Looks like the genie is working on your reward! Spin again',
    icon: GAMIFICATION_ICONS.GENIE_ICON,
    btnText: 'Spin Again'
  },
  {
    errorCode: 5040,
    errorMessage: 'Looks like the genie is working on your reward! Retry again',
    icon: GAMIFICATION_ICONS.GENIE_ICON,
    btnText: 'Retry'
  }
];

export const AJIO_CASH_VIEW_TC_URL = `${parentUrl}/fee-payment-promotion-policy`;
export const COUPON_VIEW_TC_URL = `${parentUrl}/ajio-own-sale-policy`;
export const AJIO_WALLET_PAGE_URL = '/my-account/ajio-wallet';
export const MY_REWARDS_PAGE_URL = '/my-account/my-rewards';
export const WEB_SHARE_TITLE =
  'I earned an exciting reward on AJIO! You can also play this fun game!';
export const WEB_SHARE_IMAGE_NAME = 'stw-ajio-trophy.jpg';
export const WEB_SHARE_IMAGE_URL = imageBasePath + WEB_SHARE_IMAGE_NAME;
export const WEB_SHARE_IMAGE_MIME_TYPE = 'image/jpeg';
export const OFFER_TYPE_AJIO_CASH = 'AJIO_CASH';
export const OFFER_TYPE_AJIO_POINTS = 'AJIO_POINTS';
export const OFFER_TYPE_PROMO_COUPON = 'PROMO_COUPON';

export const cssStyles = {
  desktop: {
    content: {
      fontFamily: 'Muli',
      position: 'relative',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      height: '100vh',
      background: 'transparent',
      border: 'none',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflowY: 'scroll',
      overflowX: 'hidden'
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflowY: 'hidden',
      top: 'unset',
      zIndex: 101,
      height: '88vh',
      transition: `opacity 400ms ease-in-out 0.4s`
    }
  },
  mobile: {
    content: {
      fontFamily: 'Muli',
      position: 'relative',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      height: '100vh',
      background: 'transparent',
      border: 'none',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflowY: 'scroll',
      overflowX: 'hidden'
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflowY: 'hidden',
      zIndex: 101,
      transition: `opacity 400ms ease-in-out 0.4s`
    }
  }
};

export const GAMIFICATION_MUSIC_FILES = {
  SPIN_STOP_MUSIC_FILE: `${audioBasePath}spin-stop.mp3`,
  SUCCESS_MUSIC_FILE: `${audioBasePath}success.mp3`,
  BACKGROUND_MUSIC_FILE: `${audioBasePath}bgmusic.mp3`,
  BUTTON_TAP_MUSIC_FILE: `${audioBasePath}button_tap.mp3`
};

export const NO_OFFER_MODAL_CONTENT = {
  headerContent: 'Oops, hard luck today',
  subHeaderContent: 'Better luck next time.',
  dartboardIcon: `${imageBasePath}stw-dartboard.svg`,
  termsUrl: `${parentUrl}/fee-payment-promotion-policy`,
  btnLabel: 'Continue Shopping',
  btnUrl: '/',
  closeIcon: GAMIFICATION_ICONS.MODAL_CIRCLE_CLOSE_ICON
};
